export default "__VITE_ASSET__BJY7ZTQW__"